import React, { useState } from "react";
import NewsLetter from "./components/NewsLetter";
import "./css/Home.css";
import "./css/CustomModal.css";
import "./css/KirnavaliDetails.css";
import heroBg from "../images/kirnavalibanner.png";

// Hero Section Images for the automatic right-side carousel (swapped every 3s)
import heroImage1 from '../images/kirnavaliicon.png';
import dynamicBg from "../images/Banner6.png"; // New background image asset
import thumb1 from "../images/core1.png";
import thumb2 from "../images/core2.png";
import thumb3 from "../images/core3.png";
import thumb4 from "../images/core4.png";
// Add assets for the expandable cards as well

// Reusing pathway milestone images (can use sample banner/associate images)
import stepImg1 from '../images/aden1.png';
import stepImg2 from '../images/aden1.png';
import stepImg3 from '../images/aden1.png';
import stepImg4 from '../images/aden1.png';
import stepImg5 from '../images/aden1.png';
import stepImg6 from '../images/aden1.png';
import stepImg7 from '../images/aden1.png';
import stepImg8 from '../images/aden1.png';
import stepImg9 from '../images/aden1.png';
import stepImg10 from '../images/aden1.png';
import stepImg11 from '../images/aden1.png';
import stepImg12 from '../images/aden1.png';
import stepImg13 from '../images/aden1.png';
import stepImg14 from '../images/aden1.png';


import kirnavaliDetails from '../images/Banner2.png';


import Footer from "./components/Footer";

import { FaQuoteLeft } from "react-icons/fa";
import FloatingMenuKirnavali from "./components/FloatingMenuKirnavali";
import NavbarKirnavali from "./components/NavbarKirnavali";
import NonSchoolKirnavali from "./components/NonSchoolKirnavali";

import {
    FaGraduationCap,
    FaBookOpen,
    FaBrain,
    FaTrophy,
    FaArrowRight,
    FaCheck
} from "react-icons/fa";

function Kirnavali() {

    // Array holding all box content items
    const allBoxes = [
        {
            id: 1,
            img: thumb1,
            title: "Comprehensive Academic Diagnostics",
            subtitle: "Evaluate every student's learning progress with detailed classroom-wide performance insights.",
            link: "https://kirnavali.crestestlearning.com/"
        },
        {
            id: 2,
            img: thumb2,
            title: "Restoring Joy to Learning",
            subtitle: "Healthy academic challenges reduce exam stress and make learning engaging for every student.",
            link: "https://kirnavali.crestestlearning.com/"
        },
        {
            id: 3,
            img: thumb3,
            title: "Transparent & Trusted AI Analytics",
            subtitle: "AI-powered assessments with independent moderation ensure fair, accurate, and reliable evaluation.",
            link: "https://kirnavali.crestestlearning.com/"
        },
        {
            id: 4,
            img: thumb4,
            title: "An Elite Institutional Legacy",
            subtitle: "Strengthen your school's reputation through a future-ready academic framework aligned with NEP.",
            link: "https://kirnavali.crestestlearning.com/"
        },
    ];

    // State tracker toggles whether all elements show or just the initial 4
    const [showAll, setShowAll] = useState(false);

    // Filters items dynamically based on the toggle state
    const visibleBoxes = showAll ? allBoxes : allBoxes.slice(0, 4);



    const [activeStep, setActiveStep] = useState(null);

    const [selectedJourney, setSelectedJourney] = useState(null);
    const [showJourneyModal, setShowJourneyModal] = useState(false);

    const journeyBenefits = {
        registration: {
            number: "01",
            title: "Registration",
            subtitle: "Begin Your Kirnavali Journey",
            icon: FaGraduationCap,
            color: "#207AB4",
            description:
                "Register through your school referral code and get access to the Kirnavali National Challenge platform.",
            benefits: [
                "Official Kirnavali student registration",
                "Personal student account",
                "Access to your Kirnavali dashboard",
                "Track your examination journey",
                "View eligibility and progress",
                "Participate in the national academic challenge"
            ]
        },

        level1: {
            number: "02",
            title: "Level 1",
            subtitle: "Regional Academic Assessment",
            icon: FaBookOpen,
            color: "#0F4F67",
            description:
                "Complete the Level 1 academic assessment covering core school subjects and qualify for the next stage.",
            benefits: [
                "Mathematics assessment",
                "Science assessment",
                "Social Science assessment",
                "Instant assessment result",
                "AI-powered performance insights",
                "Qualify for Level 2 on meeting the required score",
                "Unlock Crestest Online Exam Subscription"
            ]
        },

        level2: {
            number: "03",
            title: "Level 2",
            subtitle: "Quiz & Aptitude Challenge",
            icon: FaBrain,
            color: "#13817D",
            description:
                "Take the advanced Quiz and Aptitude assessment and unlock additional learning resources by qualifying.",
            benefits: [
                "Advanced Quiz assessment",
                "Aptitude assessment",
                "Instant performance analysis",
                "Subject-wise performance insights",
                "Qualification for Level 3",
                "FREE Online Exam access",
                "Full E-Library access"
            ]
        },

        level3: {
            number: "04",
            title: "Level 3",
            subtitle: "Skill, Creativity & Excellence",
            icon: FaTrophy,
            color: "#178A84",
            description:
                "Showcase your creativity, reasoning, communication and analytical skills through advanced skill-based activities.",
            benefits: [
                "Essay Writing",
                "Puzzle Solving",
                "Creativity evaluation",
                "Critical Thinking",
                "Logical Reasoning",
                "Communication skills evaluation",
                "Expert moderator evaluation",
                "Opportunity for national ranking",
                "Certificates, mementos and goodies",
                "Exciting prizes and recognition"
            ]
        }
    };

    const openJourneyModal = (journeyKey) => {
        setSelectedJourney(journeyBenefits[journeyKey]);
        setShowJourneyModal(true);
    };

    const closeJourneyModal = () => {
        setShowJourneyModal(false);

        setTimeout(() => {
            setSelectedJourney(null);
        }, 250);
    };


    // 14 Pathway Stops Data with images, larger headings, and sub-descriptions
    const pathwaySteps = [
        {
            id: 1,
            title: "School Referral",
            subdesc: "School shares the Kirnavali referral code.",
            points: [
                "Unique referral code",
                "Shared with students",
                "School participation"
            ],
            position: { top: "20%", left: "6%" },
            img: stepImg1
        },
        {
            id: 2,
            title: "Student Registration",
            subdesc: "Register using the school referral code.",
            points: [
                "Online registration",
                "Referral verification",
                "Profile creation"
            ],
            position: { top: "45%", left: "11%" },
            img: stepImg2
        },
        {
            id: 3,
            title: "Student Login",
            subdesc: "Access the Kirnavali portal.",
            points: [
                "Secure login",
                "Student account",
                "Dashboard access"
            ],
            position: { top: "72%", left: "16%" },
            img: stepImg3
        },
        {
            id: 4,
            title: "Student Dashboard",
            subdesc: "Track your complete journey.",
            points: [
                "Progress Tracker",
                "Badges",
                "Resources",
                "Notifications",
                "Eligibility"
            ],
            position: { top: "82%", left: "26%" },
            img: stepImg4
        },
        {
            id: 5,
            title: "Academic Details",
            subdesc: "Choose Board & Class.",
            points: [
                "CBSE / ICSE / State Board",
                "Select Class",
                "Exam eligibility"
            ],
            position: { top: "62%", left: "30%" },
            img: stepImg5
        },
        {
            id: 6,
            title: "Regional Examination",
            subdesc: "Board & class specific assessment.",
            points: [
                "Regional exam",
                "Board specific",
                "Class specific"
            ],
            position: { top: "36%", left: "28%" },
            img: stepImg6
        },
        {
            id: 7,
            title: "Level 1 Assessment",
            subdesc: "Regional Academic Test.",
            points: [
                "Math (20)",
                "Science (15)",
                "Social Science (15)",
                "50 Marks • 60 Min",
                "80% to qualify"
            ],
            position: { top: "18%", left: "36%" },
            img: stepImg7
        },
        {
            id: 8,
            title: "Level 2 Assessment",
            subdesc: "Quiz & Aptitude Test.",
            points: [
                "Quiz Test (25)",
                "Aptitude (25)",
                "50 Marks • 30 Min",
                "90% to qualify",
                "FREE LMS Reward"
            ],
            position: { top: "22%", left: "48%" },
            img: stepImg8
        },
        {
            id: 9,
            title: "Level 3 - SWIFT",
            subdesc: "Skill-based evaluation.",
            points: [
                "Essay Writing",
                "Puzzle Solving",
                "Creativity",
                "Critical Thinking"
            ],
            position: { top: "46%", left: "52%" },
            img: stepImg9
        },
        {
            id: 10,
            title: "Essay Submission",
            subdesc: "Submit to moderator panel.",
            points: [
                "Essay upload",
                "Moderator review",
                "Verification"
            ],
            position: { top: "70%", left: "50%" },
            img: stepImg10
        },
        {
            id: 11,
            title: "Moderator Evaluation",
            subdesc: "Expert assessment process.",
            points: [
                "Essay Review",
                "Creativity",
                "Communication",
                "Analytical Thinking",
                "Score Allocation"
            ],
            position: { top: "84%", left: "62%" },
            img: stepImg11
        },
        {
            id: 12,
            title: "Combined Ranking",
            subdesc: "Final merit calculation.",
            points: [
                "Puzzle Score",
                "Essay Score",
                "Overall Ranking"
            ],
            position: { top: "64%", left: "73%" },
            img: stepImg12
        },
        {
            id: 13,
            title: "Top 10 Finalists",
            subdesc: "National toppers selected.",
            points: [
                "Top 10 Ranking",
                "National Recognition",
                "Final Qualification"
            ],
            position: { top: "40%", left: "78%" },
            img: stepImg13
        },
        {
            id: 14,
            title: "Grand Rewards",
            subdesc: "Celebrate excellence.",
            points: [
                "Premium LMS",
                "Mementos",
                "Goodies",
                "Leaderboard",
                "Certificates"
            ],
            position: { top: "22%", left: "89%" },
            img: stepImg14
        }
    ];
    return (
        <>
            <FloatingMenuKirnavali />

            {/* Existing Hero Section */}
            <section
                className="hero-section"
                style={{
                    backgroundImage: `url(${heroBg})`,
                }}
            >
                <NavbarKirnavali />

                <div className="container hero-content">
                    <div className="row align-items-center">
                        {/* Left Section (Increased Width) */}
                        <div className="col-lg-7 col-md-12 mb-4 mb-lg-0">
                            <div className="hero-left">
                                <p className="hero-small-text">National Academic Challenge</p>

                                <h1 className="hero-heading">
                                    <span style={{ color: "#FBBB1B" }}>
                                        Kirnavali
                                    </span>
                                    {" "}– Learn, Compete & Shine
                                </h1>

                                <p className="hero-sub-text" style={{ color: "white" }}>
                                    <strong>Kirnavali</strong> is a national-level academic challenge for students of
                                    Classes 7–10. Register to test your knowledge, improve your skills with
                                    AI-powered assessments, unlock exciting learning rewards, and earn
                                    mementoes, prizes, goodies and national recognition.
                                </p>

                                <a
                                    href="https://kirnavali.crestestlearning.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn hero-btn"
                                >
                                    REGISTER FOR KIRNAVALI
                                </a>
                            </div>
                        </div>

                        {/* Right Section (Single Auto-Scrolling Image Every 3 Seconds) */}
                        <div className="col-lg-5 col-md-12">
                            <div className="hero-right w-100">
                                <div className="hero-single-image-wrapper w-100 rounded-4 overflow-hidden bg-transparent" style={{ height: '420px' }}>
                                    <img
                                        // src={heroImages[currentHeroImageIndex]}
                                        src={heroImage1}
                                        alt="Kirnavali National Challenge Showcase"
                                        className="hero-fade-image w-100 h-100 object-fit-cover bg-transparent"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <div className="row g-4 justify-content-center mt-5">

                <div className="col-lg col-md-6">
                    <div
                        className="journey-box text-center text-white h-100"
                        style={{ background: "#071A3E" }}
                    >
                        <h3>01</h3>
                        <h5>Register</h5>
                        <p>
                            Register using your school's referral code and begin your
                            Kirnavali National Challenge journey.
                        </p>
                    </div>
                </div>

                <div className="col-lg col-md-6">
                    <div
                        className="journey-box text-center text-white h-100"
                        style={{ background: "#0A2A52" }}
                    >
                        <h3>02</h3>
                        <h5>Level 1</h5>
                        <p>
                            Score <strong>75%+</strong> to qualify and unlock a
                            <strong> FREE Crestest Online Exam Subscription.</strong>
                        </p>
                    </div>
                </div>

                <div className="col-lg col-md-6">
                    <div
                        className="journey-box text-center text-white h-100"
                        style={{ background: "#0F4F67" }}
                    >
                        <h3>03</h3>
                        <h5>Level 2</h5>
                        <p>
                            Score <strong>75%+</strong> again to receive
                            <strong> FREE Online Exams + Full E-Library Access.</strong>
                        </p>
                    </div>
                </div>

                <div className="col-lg col-md-6">
                    <div
                        className="journey-box text-center text-white h-100"
                        style={{ background: "#13817D" }}
                    >
                        <h3>04</h3>
                        <h5>Level 3</h5>
                        <p>
                            Showcase essay writing, creativity, logical reasoning,
                            communication, puzzles, and analytical skills.
                        </p>
                    </div>
                </div>

                <div className="col-lg col-md-6">
                    <div
                        className="journey-box text-center text-white h-100"
                        style={{ background: "#178A84" }}
                    >
                        <h3>05</h3>
                        <h5>Rewards</h5>
                        <p>
                            Win Certificates, Mementos, Goodies, Exciting Gifts,
                            Cash Prizes, and National Recognition.
                        </p>
                    </div>
                </div>

            </div> */}

            <section className="py-5 bg-white">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="p-5 text-center position-relative quote-box-wrapper">
                                <FaQuoteLeft
                                    className="mb-3"
                                    style={{
                                        fontSize: "40px",
                                        color: "#57BDB9",
                                        opacity: 0.6,
                                    }}
                                />

                                <h3
                                    className="mb-4"
                                    style={{
                                        color: "#207AB4",
                                        fontWeight: "800",
                                        fontSize: "24px",
                                    }}
                                >
                                    About Kirnavali
                                </h3>

                                <p className="lead px-md-4 quote-text">
                                    <strong>Kirnavali</strong> is an <strong>NEP-aligned inter-school academic challenge</strong> designed to promote competency-based learning through a structured <strong>three-level assessment</strong> covering <strong>Mathematics, Science, Social Science, Aptitude, and General Awareness</strong>. The final level further evaluates students through <strong>creative writing, puzzle solving, logical reasoning, and other skill-based activities.</strong>

                                    <br /><br />

                                    Students who qualify at each level unlock <strong>exclusive Crestest learning rewards</strong>, while top performers receive <strong>certificates, mementos, goodies, and cash prizes.</strong>

                                    <br /><br />

                                    Powered by <strong>Crestest's AI-driven examination platform</strong>, every student receives a <strong>unique MCQ question set</strong>, ensuring a fair and transparent assessment. Upon submission, students instantly receive an <strong>AI-generated performance report</strong> with detailed analytics, strengths, improvement areas, and subject-wise insights to support their academic growth.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ================= KIRNAVALI JOURNEY UNLOCKS ================= */}
            <section className="kirnavali-unlocks-section py-5">

                <div className="container">

                    <div className="text-center mb-5">

                        <span className="kirnavali-section-badge">
                            YOUR KIRNAVALI JOURNEY
                        </span>

                        <h2 className="kirnavali-unlocks-heading">
                            What Do You Unlock at Every Stage?
                        </h2>

                        <p className="kirnavali-unlocks-subheading">
                            Progress through each stage, unlock new learning opportunities,
                            and move closer to national recognition.
                        </p>

                    </div>


                    <div className="kirnavali-unlock-timeline">

                        {/* Registration */}
                        <div
                            className="unlock-stage-card"
                            onClick={() => openJourneyModal("registration")}
                        >
                            <div
                                className="unlock-stage-number"
                                style={{ background: "#207AB4" }}
                            >
                                01
                            </div>

                            <div className="unlock-stage-icon">
                                <FaGraduationCap />
                            </div>

                            <h3>Registration</h3>

                            <p>
                                Register through your school referral code and begin
                                your Kirnavali journey.
                            </p>

                            <button type="button">
                                VIEW UNLOCKS <FaArrowRight />
                            </button>
                        </div>


                        {/* Connector */}
                        <div className="unlock-connector">
                            <FaArrowRight />
                        </div>


                        {/* Level 1 */}
                        <div
                            className="unlock-stage-card"
                            onClick={() => openJourneyModal("level1")}
                        >
                            <div
                                className="unlock-stage-number"
                                style={{ background: "#0F4F67" }}
                            >
                                02
                            </div>

                            <div className="unlock-stage-icon">
                                <FaBookOpen />
                            </div>

                            <h3>Level 1</h3>

                            <p>
                                Complete the Regional Academic Assessment and
                                qualify for the next stage.
                            </p>

                            <button type="button">
                                VIEW UNLOCKS <FaArrowRight />
                            </button>
                        </div>


                        {/* Connector */}
                        <div className="unlock-connector">
                            <FaArrowRight />
                        </div>


                        {/* Level 2 */}
                        <div
                            className="unlock-stage-card"
                            onClick={() => openJourneyModal("level2")}
                        >
                            <div
                                className="unlock-stage-number"
                                style={{ background: "#13817D" }}
                            >
                                03
                            </div>

                            <div className="unlock-stage-icon">
                                <FaBrain />
                            </div>

                            <h3>Level 2</h3>

                            <p>
                                Challenge yourself with Quiz and Aptitude and
                                unlock additional learning resources.
                            </p>

                            <button type="button">
                                VIEW UNLOCKS <FaArrowRight />
                            </button>
                        </div>


                        {/* Connector */}
                        <div className="unlock-connector">
                            <FaArrowRight />
                        </div>


                        {/* Level 3 */}
                        <div
                            className="unlock-stage-card"
                            onClick={() => openJourneyModal("level3")}
                        >
                            <div
                                className="unlock-stage-number"
                                style={{ background: "#178A84" }}
                            >
                                04
                            </div>

                            <div className="unlock-stage-icon">
                                <FaTrophy />
                            </div>

                            <h3>Level 3</h3>

                            <p>
                                Showcase creativity, reasoning, communication and
                                analytical skills.
                            </p>

                            <button type="button">
                                VIEW UNLOCKS <FaArrowRight />
                            </button>
                        </div>

                    </div>

                </div>
            </section>


            {/* ================= CUSTOM JOURNEY MODAL ================= */}
            {showJourneyModal && selectedJourney && (
                <div
                    className="kirnavali-modal-overlay"
                    onClick={closeJourneyModal}
                >

                    {/* Left Sparkles */}
                    <div className="modal-sparkles modal-sparkles-left">
                        <span>✦</span>
                        <span>✧</span>
                        <span>✦</span>
                        <span>✧</span>
                        <span>✦</span>
                        <span>✧</span>
                        <span>✦</span>
                    </div>


                    {/* Right Sparkles */}
                    <div className="modal-sparkles modal-sparkles-right">
                        <span>✦</span>
                        <span>✧</span>
                        <span>✦</span>
                        <span>✧</span>
                        <span>✦</span>
                        <span>✧</span>
                        <span>✦</span>
                    </div>


                    {/* Modal */}
                    <div
                        className="kirnavali-unlock-modal"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <button
                            className="kirnavali-modal-close"
                            onClick={closeJourneyModal}
                            aria-label="Close"
                        >
                            ×
                        </button>


                        <div
                            className="modal-stage-icon"
                            style={{
                                background: selectedJourney.color
                            }}
                        >
                            <selectedJourney.icon />
                        </div>


                        <div className="modal-stage-number">
                            STAGE {selectedJourney.number}
                        </div>


                        <h2>
                            {selectedJourney.title}
                        </h2>


                        <h4>
                            {selectedJourney.subtitle}
                        </h4>


                        <p className="modal-description">
                            {selectedJourney.description}
                        </p>


                        <div className="modal-unlock-heading">
                            What You Get
                        </div>


                        <div className="modal-benefits-grid">

                            {selectedJourney.benefits.map((benefit, index) => (
                                <div
                                    className="modal-benefit-item"
                                    key={index}
                                >
                                    <span
                                        className="benefit-check"
                                        style={{
                                            background: selectedJourney.color
                                        }}
                                    >
                                        <FaCheck />
                                    </span>

                                    <span>
                                        {benefit}
                                    </span>
                                </div>
                            ))}

                        </div>


                        <button
                            className="modal-close-bottom"
                            onClick={closeJourneyModal}
                        >
                            CONTINUE YOUR JOURNEY
                        </button>

                    </div>

                </div>
            )}

            <section className="kirnavali-pathway-section py-5" style={{ backgroundImage: `url(${kirnavaliDetails})` }}>
                <div className="container text-center my-4">
                    <span className="badge px-3 py-1 rounded-pill fw-bold mb-2 shadow-sm" style={{ backgroundColor: '#207AB4', color: '#ffffff' }}>
                        Roadmap to Glory
                    </span>
                    <h2 className="fw-bold display-6 mb-3" style={{ color: '#207AB4' }}>The Kirnavali Challenge Pathway</h2>
                    <p className="text-muted mx-auto mb-5" style={{ maxWidth: '650px' }}>
                        Navigate through our carefully curated 14-step journey designed to test, elevate, and celebrate academic excellence. Hover over each stop to explore details.
                    </p>

                    {/* Pathway Container Map */}
                    <div className="pathway-map-container position-relative mx-auto">

                        {/* SVG Winding Path Connecting Line matching coordinates cleanly */}
                        <svg className="pathway-svg-line" viewBox="0 0 1000 600" preserveAspectRatio="none">
                            <path
                                d="M 60,120 C 110,270 110,430 160,500 C 210,570 260,550 300,380 C 340,210 360,110 480,130 C 600,150 520,380 500,500 C 480,620 620,620 730,420 C 840,220 840,180 890,130"
                                fill="none"
                                stroke="#207AB4"
                                strokeWidth="4"
                                strokeDasharray="8 8"
                                className="pathway-animated-dash"
                            />
                        </svg>

                        {/* 14 Interactive Stops */}
                        {pathwaySteps.map((step) => (
                            <div
                                key={step.id}
                                className={`pathway-pointer-node ${activeStep === step.id ? 'active-node' : ''}`}
                                style={{ top: step.position.top, left: step.position.left }}
                                onMouseEnter={() => setActiveStep(step.id)}
                                onMouseLeave={() => setActiveStep(null)}
                            >
                                <div className="pointer-pin">
                                    <span className="pointer-number">{step.id}</span>
                                </div>

                                {/* Clean Label Card below pointer with larger fonts */}
                                <div className="pointer-label-card text-start shadow-sm">
                                    <h6 className="fw-bold text-dark mb-1">{step.title}</h6>
                                    <p className="text-muted mb-0">{step.subdesc}</p>
                                </div>

                                {/* Expanded Tooltip Card with Image, Larger Heading, and Subtext */}
                                <div className="pathway-tooltip shadow-lg">
                                    {/* <div className="tooltip-img-wrapper mb-2 rounded-2 overflow-hidden">
                                        <img src={step.img} alt={step.title} className="w-100 h-100 object-fit-cover" />
                                    </div> */}
                                    <h5 className="fw-bold text-primary mb-1">{step.title}</h5>
                                    <p className="text-dark fw-semibold mb-2">{step.subdesc}</p>
                                    <ul className="list-unstyled text-start text-secondary mb-0">
                                        {step.points.map((pt, i) => (
                                            <li key={i} className="mb-1 d-flex align-items-center">
                                                <span className="me-2 text-warning fw-bold">•</span> {pt}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <NonSchoolKirnavali />


            {/* 4. NEW: Expandable Grid Grid Section */}
            <section
                className="dynamic-grid-section"
                style={{ backgroundImage: `url(${dynamicBg})` }}
            >
                <div className="container">

                    {/* Section Header */}
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8 d-flex flex-column align-items-center">
                            <p className="cards-small-text">KIRNAVALI PARTICIPATION</p>

                            <h2 className="cards-main-heading">
                                The Core Value of Kirnavali Participation
                            </h2>

                            <div className="zigzag-border"></div>
                        </div>
                    </div>

                    {/* Responsive 4-Column Grid Array */}
                    <div className="row g-4 justify-content-center transition-grid">
                        {visibleBoxes.map((box) => (
                            <div className="col-sm-6 col-md-4 col-lg-3" key={box.id}>
                                <div className="grid-item-card">
                                    <div className="grid-thumb-wrap">
                                        <img src={box.img} alt={box.title} className="grid-card-img" />
                                    </div>
                                    <div className="grid-card-body text-center">
                                        <h4 className="grid-title">{box.title}</h4>
                                        <p className="grid-subtitle">{box.subtitle}</p>
                                        {/* <a href={box.link} className="btn grid-action-btn">
                                            VIEW DETAILS
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Expandable Pagination Control Button */}
                    {allBoxes.length > 4 && (
                        <div className="row mt-5">
                            <div className="col-12 text-center">
                                <button
                                    className="btn view-more-toggle-btn"
                                    onClick={() => setShowAll(!showAll)}
                                >
                                    {showAll ? "SHOW LESS" : "VIEW MORE"}
                                </button>
                            </div>
                        </div>
                    )}

                </div>
            </section>





            {/* Download App Section */}
            {/* <DownloadApp /> */}




            {/* 8. NEW: Modular Newsletter Component */}
            <NewsLetter />

            {/* 9. NEW: Footer Component */}
            <Footer />
        </>
    );
}

export default Kirnavali;